/**
 *
 */

import React, { useState, useEffect } from "react";

/* Import configuration starts */
import { useLocation } from "react-router-dom";
/* Import configuration ends */

/* Import redux slices component starts */
/* Import redux slices component ends */

/* Import react bootstrap component starts */
/* Import react bootstrap component ends */

/* Import image and SVG starts */
/* Import image and SVG ends */

/* Import local pages and component starts */
import AddPaymentSetting from "../../components/module/Payment/AddPaymentSetting/AddPaymentSetting";
import BreadCrumb from "../../components/ui/other/BreadCrumb/BreadCrumb";
/* Import local pages and component ends */

/* Component starts */
const AddPaymentSettingPage = (props) => {
  /* Props destructuring starts */
  const {} = props;
  /* Props destructuring ends */

  /* Component states and useRef declaration starts */
  /* Component states and useRef declaration ends */

  /* Other hooks declaration starts */
  const { state } = useLocation();
  /* Other hooks declaration ends */

  /* Component variable declaration / object destructure starts */
  /* Component variable declaration / object destructure ends */

  /* Component function definition starts */
  /* Component function definition ends */

  /* Component useEffect starts */
  /* Component useEffect ends */

  /* ************* Component rendering. JSX code ************* */
  return (
    <>
      <BreadCrumb type="settings_payment_edit_page" />
      <div>
        <h2 className="heading font_xxl text-center">Update Payment Setting</h2>
        <AddPaymentSetting data={state} />
      </div>
    </>
  );
};
/* Component ends */

export default AddPaymentSettingPage;
